
import { ref } from "@vue/runtime-core";

export default {
  name: "slider",
  props: {
    data: {
      // 菜单数据
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
  setup(props: any) {
    const list: any = ref([]);
    props.data.forEach((item: any) => {
      list.value.push(item);
    });
    const activeIndex: any = ref(0);
    const changeIndex = (num: number) => {
      activeIndex.value =
        (activeIndex.value + num + list.value.length) % list.value.length;
    };
    return {
      list,
      activeIndex,
      changeIndex,
    };
  },
};
